/** @format */

import { Information } from './edd.model';
import { ShipModeGroupsType } from './ship-mode-group.interface';

export class CheckoutShipping {
  public available: ShipModeGroupsType;
  public information?: Information;
  public selected?: ShipModeGroupsType;
  public shippingDefaulted?: boolean;
  public sameBillingShipping?: boolean;
}
